import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import styles from './ErrorScreen.module.scss'
import gohuntLogo from '../../assets/img/logo_maps_2x.png'

export default function ErrorScreen({ actions = [], message = '', timeout = 0, timeoutMessage = '', title = '' }) {
  const [countdown, setCountdown] = useState(timeout)

  useEffect(() => {
    if (timeout === 0) return
    if (actions.length === 0 || !actions[0].onAction) return
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer)
          actions[0].onAction()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [timeout, actions])

  return (
    <div className={styles.errorScreenContainer}>
      <div className={styles.contentContainer}>
        <figure>
          <img alt='GoHunt Logo' src={gohuntLogo} width={120} height={120} />
        </figure>
        <h1>{title || 'Error'}</h1>
        <p>{message || 'An error occurred.'}</p>

        {timeout > 0 && countdown > 0 && timeoutMessage && (
          <p className={styles.countdown}>{timeoutMessage.replace('{countdown}', countdown) + ` ${countdown !== 1 ? 'seconds' : 'second'}...`}</p>
        )}

        {actions.length > 0 && (
          <div className={styles.actionsContainer}>
            {actions.map((action, index) => (
              <button key={index} className={styles.actionButton} onClick={action.onAction}>
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

ErrorScreen.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onAction: PropTypes.func.isRequired
    })
  ),
  timeout: PropTypes.number,
  timeoutMessage: PropTypes.string
}
